// extracted by mini-css-extract-plugin
export default {"home_business":"Customer_home_business__tQBaC","inner":"Customer_inner__TSVu-","image_box":"Customer_image_box__IMbl1","image":"Customer_image__0zNST"};